import React from "react";
import { formatBook } from "../../../utils/formatOdds";

const IMG = `${import.meta.env.BASE_URL}img`;

const isOpen = (m) => String(m?.gstatus || "").toUpperCase() === "OPEN";
const bySr = (list) => list.slice().sort((a, b) => (Number(a?.sr) || 0) - (Number(b?.sr) || 0));

/**
 * The Trap bet area in the reference markup (.casino-table.trap .casino-detail):
 *   .teen1daycasino-container: Player A | Player B (back / lay)
 *   .teen1daycasino-container: visible "highlow" card (.seven-up-down-box LOW / 7 / HIGH) | visible "jqk" card (J Q K back / lay)
 *   .teen1daycasino-container.trap-number (number strip image)
 */
export default function BetTableTrapRef({ sub = [], exposures = {}, onOdds }) {
  const list = Array.isArray(sub) ? sub : [];
  const trap = bySr(list.filter((m) => m?.subtype === "trap"));
  const highLow = bySr(list.filter((m) => m?.subtype === "highlow"));
  const jqk = bySr(list.filter((m) => m?.subtype === "jqk"));

  const exp = (name) => {
    const v = exposures[name] ?? exposures[String(name || "").toLowerCase()];
    return v != null ? Number(v) || 0 : 0;
  };
  const bookCls = (v) => (v > 0 ? "book-green" : "book-red");
  const susp = (m) => (isOpen(m) ? "" : " suspended");

  const player = (m, name) => {
    const e = exp(m?.nat || name);
    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{name}</b>{" "}
          <div className="float-right">
            <span className={`mr-2 ${bookCls(e)}`}>{formatBook(e)}</span>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${susp(m)}`} onClick={() => onOdds?.(m, m?.b, "back")}>
            <span className="casino-box-odd">{m?.b ?? 0}</span>
          </div>{" "}
          <div className={`lay casino-bl-box-item${susp(m)}`} onClick={() => onOdds?.(m, m?.l, "lay")}>
            <span className="casino-box-odd">{m?.l ?? 0}</span>
          </div>
        </div>
      </div>
    );
  };

  const sevenBox = (s) => {
    const odds = (Array.isArray(s.odds) ? s.odds : []).slice().sort((a, b) => (Number(b?.sno) || 0) - (Number(a?.sno) || 0));
    // Reference book directive adds .lock-top to its suspended parent (the up / down box)
    const lock = isOpen(s) ? "" : " suspended lock-top";
    return (
      <div key={s.sid} className="seven-up-down-box">
        {odds.map((o, i) => {
          // stored "Card 3 High" / "Card 3 Low"
          const e = exp(`${s.nat} ${o?.nat}`);
          const book = <div className={`up-down-book ${bookCls(e)}`}>{formatBook(e)}</div>;
          return (
            <React.Fragment key={o?.sid ?? i}>
              {i > 0 && " "}
              {Number(o?.sid) === 2 && (
                <div className={`up-box${lock}`} onClick={() => onOdds?.(s, o?.b, "back", o)}>
                  {book}{" "}
                  <div className="text-right">
                    <div className="up-down-odds">{o?.b}</div> <span>LOW</span>
                  </div>
                </div>
              )}{" "}
              {Number(o?.sid) === 1 && (
                <div className={`down-box${lock}`} onClick={() => onOdds?.(s, o?.b, "back", o)}>
                  <div className="text-left">
                    <div className="up-down-odds">{o?.b}</div> <span>HIGH</span>
                  </div>{" "}
                  {book}
                </div>
              )}
            </React.Fragment>
          );
        })}{" "}
        <div className="seven-box">
          <img src={`${IMG}/trap/trape-seven.png`} alt="" />
        </div>
      </div>
    );
  };

  const jqkRow = (s) => {
    const o = (Array.isArray(s.odds) && s.odds[0]) || {};
    // stored "Card 3 JQK"
    const e = exp(`${s.nat} JQK`);
    return (
      <div key={s.sid} className="casino-box-row jqk-box">
        <div className="casino-nation-name">
          <span>
            <img src={`${IMG}/cards/J.png`} alt="" /> <img src={`${IMG}/cards/Q.png`} alt="" />{" "}
            <img src={`${IMG}/cards/K.png`} alt="" />
          </span>{" "}
          <div className="float-right">
            <span className={`mr-2 ${bookCls(e)}`}>{formatBook(e)}</span>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${susp(s)}`} onClick={() => onOdds?.(s, o?.b, "back", o)}>
            <span className="casino-box-odd">{o?.b}</span>
          </div>{" "}
          <div className={`lay casino-bl-box-item${susp(s)}`} onClick={() => onOdds?.(s, o?.l, "lay", o)}>
            <span className="casino-box-odd">{o?.l}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">{player(trap[0], "Player A")}</div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">{player(trap[1], "Player B")}</div>
      </div>{" "}
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">{highLow.filter((s) => Number(s?.visible) === 1).map(sevenBox)}</div>{" "}
        <div className="teen1daycenter" />{" "}
        <div className="teen1dayright">{jqk.filter((s) => Number(s?.visible) === 1).map(jqkRow)}</div>
      </div>{" "}
      <div className="teen1daycasino-container trap-number">
        <img src={`${IMG}/trap/trap-number-bg.jpg`} className="img-fluid" alt="" />
      </div>
    </>
  );
}
